exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ne6Ax{background:#f3d8d8}._2NYJa{background:#bce0bc}.s_IIK{background:#fff}._3ISOy{padding:0!important}._2bwNS{padding:7px 3px}.eGU46 div{overflow-x:hidden!important}.eGU46 div div div div{overflow:hidden!important}.eGU46 ._1BbdL,.eGU46 ._1bpwJ,.eGU46 ._1tAKz,.eGU46 ._2Ljmg{overflow-x:hidden!important}.eGU46 ._3NIGZ,.eGU46 .AUryD ._2jBlP{white-space:normal!important;word-break:break-word!important}", ""]);

// exports
exports.locals = {
	"pendiente": "ne6Ax",
	"procesada": "_2NYJa",
	"normal": "s_IIK",
	"tdClear": "_3ISOy",
	"field": "_2bwNS",
	"hidden": "eGU46",
	"rt-table": "_1BbdL",
	"rt-tbody": "_1tAKz",
	"rt-thead": "_2Ljmg",
	"rt-tfoot": "_1bpwJ",
	"rt-tr": "AUryD",
	"rt-td": "_2jBlP",
	"rt-th": "_3NIGZ"
};